import React from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { updateBadgeInfo } from '../actions'

class BadgeName extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    editName: PropTypes.bool,
    updateInfo: PropTypes.func,
    disable: PropTypes.bool,
  }

  constructor() {
    super()
    this.state = {
      editName: false,
    }
  }

  changeMode = () => {
    this.setState({ editName: !this.state.editName })
  }

  handleChange = () => {
    let newName = this.nameInput.value
    let badgeInfo = {}
    badgeInfo.name = newName
    this.props.updateInfo(badgeInfo)
    this.changeMode()
  }

  render() {
    if (this.state.editName === true) {
      return (
        <div className="text-center input_element" id="name">
          <input
            type="text"
            id="name_input"
            ref={input => {
              this.nameInput = input
            }}
            defaultValue={this.props.name}
            onBlur={this.handleChange}
          />
        </div>
      )
    } else {
      return (
        <div
          className={
            this.props.disable ? 'text-center' : 'text-center input_element'
          }
          id="name"
        >
          {this.props.name}
          <div
            className={this.props.disable ? '' : 'icon icon_pencil'}
            id="name_pencil"
            onClick={this.changeMode}
          />
        </div>
      )
    }
  }
}
const mapStateToProps = state => {
  return {
    name: state.badgeInfo.name,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateInfo: badgeInfo => {
      dispatch(updateBadgeInfo(badgeInfo))
    },
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BadgeName)
)
